import block from "bem-css-modules";
import {Sessions} from "./Sessions";
import s from './Day.module.scss';
import classNames from "classnames";

const b = block(s);
export const Day = ({day, sessions}) => {
    return (<>
        <div className={classNames(b('header'), 'row')}>
            <div className={classNames('col-3')}>{day}</div>
            <div className={'row col-9'}>
            <div className={classNames('col-12 col-md-6', b('title'))}>Title</div>
            <div className={classNames('col-12 col-md-2', b('location'))}>Location</div>
            <div className={'col-12 col-md-4'}>Speakers</div>
            </div>
        </div>
        <Sessions sessions={sessions} />
    </>)
}
